import { render, staticRenderFns } from "./SifrarnikPopup.vue?vue&type=template&id=6a15a5b7"
import script from "./SifrarnikPopup.vue?vue&type=script&lang=js"
export * from "./SifrarnikPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports